const AddressPicker = () => null

export default AddressPicker
